import { render, staticRenderFns } from "./xiguanjie-yatongdian-left.vue?vue&type=template&id=2dfa855a&scoped=true&"
import script from "./xiguanjie-yatongdian-left.vue?vue&type=script&lang=ts&"
export * from "./xiguanjie-yatongdian-left.vue?vue&type=script&lang=ts&"
import style0 from "./xiguanjie-yatongdian-left.vue?vue&type=style&index=0&id=2dfa855a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfa855a",
  null
  
)

export default component.exports